module.exports = __webpack_public_path__ + "static/media/RCP Terms & Conditions - Footer New.c666f9f8.pdf";